import { Component, EventEmitter, Input, Output, SimpleChanges, OnChanges } from '@angular/core';
import { LeagueWeek } from '../../../../models/LeagueWeek';
import { GolfEventField } from '../../../../models/golfeventfield';
import { GolfEventService } from '../../../../services/golf-event.service';
import { GolfEventTeamScoreViewModel } from '../../../../models/viewmodels/golfEventTeamScoreViewModel';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { ApplicationService } from '../../../../services/application.service';
import { PostScoreRequest } from '../../../../models/postScoreRequest';

@Component({
  selector: 'app-post-team-round',
  standalone: true,
  imports: [NgFor, NgIf, FormsModule],
  templateUrl: './post-team-round.component.html',
  styleUrl: './post-team-round.component.css'
})
export class PostTeamRoundComponent {
  @Input() leagueWeek:LeagueWeek|null = null;
  @Input() loggedInPlayerId:number|null = null;
  @Input() paidPlayers:Array<GolfEventField> = [];
  @Output() scoresPosted = new EventEmitter<void>;

  constructor(private golfEventService:GolfEventService, private applicationService:ApplicationService) {}

  selectedTeams:Array<GolfEventTeamScoreViewModel> = [];
  allTeams:Array<GolfEventTeamScoreViewModel> = [];

  ngOnChanges(changes: SimpleChanges) {    
    if (changes['leagueWeek'] || changes['loggedInPlayerId']) {
      this.getTeams();
    }

    if (changes['paidPlayers']  || changes['loggedInPlayerId']) {
      
    }
  }

  async getTeams() {
    if(!this.leagueWeek || !this.loggedInPlayerId) return;

    this.applicationService.showGlobalSpinner();
    let teams = await this.golfEventService.searchTeams(this.leagueWeek.golfEventId);
    this.applicationService.hideGlobalSpinner();

    teams.forEach(t => {
      let vm:GolfEventTeamScoreViewModel = { isSelected: false, teamId: t.id, teamName: t.teamName, score: null, players: []};
      t.players.forEach(tp => {
        vm.players.push({ playerId: tp.id, firstName: tp.firstName, lastName: tp.lastName });
        if(tp.id.toString() === this.loggedInPlayerId?.toString())
          vm.isSelected = true;
      });
      this.allTeams.push(vm);
    });
    
    this.selectedTeams = this.allTeams.filter(t => t.isSelected);
  }

  selectTeamToPost(team:GolfEventTeamScoreViewModel) {
    team.isSelected = true;
    this.selectedTeams = this.allTeams.filter(t => t.isSelected);
  }

  removeTeamFromPost(team:GolfEventTeamScoreViewModel) {
    team.isSelected = false;
    this.selectedTeams = this.allTeams.filter(t => t.isSelected);
  }

  async postScore(form:NgForm) {
    if(!this.leagueWeek) return; 

    if(form.control.invalid) {
      alert("Invalid Form");
      return;
    }

    let leagueWeekId = this.leagueWeek.id;
    let scoresToPost:Array<PostScoreRequest> = [];
    this.selectedTeams.forEach(post => {
      scoresToPost.push({
        leagueWeekId: leagueWeekId,
        playerId: null,
        email: null,
        score: post.score ? post.score : 0,
        teamId: post.teamId
      });
    });

    let invalidScores = scoresToPost.filter(s => s.score <= 18).length > 0;

    if(invalidScores) {
      alert("One or more scores is too low and considered an invalid entry.");
      return;
    }

    this.applicationService.showGlobalSpinner();
    try {
      await this.golfEventService.postScores(scoresToPost);
      this.scoresPosted.emit();
    } finally {
      this.applicationService.hideGlobalSpinner();
    }
  }
}
